import { useEffect, useState } from "react";
import { LINKS } from "../const/config";
import { fetchStoreLinks } from "../services/linksApi";

const FALLBACK_LINKS = {
  android: LINKS.android.store,
  ios: LINKS.ios.store,
};

export function useStoreLinks() {
  const [links, setLinks] = useState({ android: "", ios: "" });
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchStoreLinks()
      .then((data) => {
        if (!cancelled) setLinks(data);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("[useStoreLinks] fetch failed, using fallback", err);
        setError(err);
        setLinks(FALLBACK_LINKS);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { links, error };
}
